import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface authCardState {
  featureName: string;
}

let initialState: authCardState = {
  featureName: localStorage.getItem("oc_all_in_FeatureName") || "",
};

const AuthCardSliceReducer = createSlice({
  name: "AuthCard",
  initialState,
  reducers: {
    setFeatureName(state, action: PayloadAction<string>) {
      state.featureName = action.payload;
    },
  },
});

export const { setFeatureName } = AuthCardSliceReducer.actions;

export default AuthCardSliceReducer.reducer;
